import React from 'react';
// Components
import AboutSivSection from './AboutSivSection';


function AboutPageMainContainer() {
  return (
    <main role='main' className='grid gap-y-8 lg:gap-y-12 w-full h-full'>
      <AboutSivSection />
    </main>
  );
}

export default AboutPageMainContainer;
